"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSystemProvider = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = (0, tslib_1.__importDefault)(require("react-dnd-html5-backend"));
const FileSystemContext_1 = require("./FileSystemContext");
const components_1 = require("./components");
const FSContextMenu_1 = require("./components/FSContextMenu");
class FileSystemProvider extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            contextMenu: null,
            selectedItems: [],
        };
        this.setState = this.setState.bind(this);
    }
    render() {
        return ((0, jsx_runtime_1.jsx)(react_dnd_1.DndProvider, Object.assign({ backend: react_dnd_html5_backend_1.default }, { children: (0, jsx_runtime_1.jsxs)(FileSystemContext_1.FileSystemContext.Provider, Object.assign({ value: {
                    props: this.props,
                    state: this.state,
                    setState: this.setState,
                } }, { children: [(0, jsx_runtime_1.jsx)(components_1.DragLayer, {}, void 0), (0, jsx_runtime_1.jsx)(FSContextMenu_1.FSContextMenu, {}, void 0), this.props.children] }), void 0) }), void 0));
    }
}
exports.FileSystemProvider = FileSystemProvider;
//# sourceMappingURL=FileSystemProvider.js.map